import { DefaultFlexProps } from "./Flex.types.js";

export const DEFAULT_FLEX_PROPS: DefaultFlexProps = {
    direction: "row",
    wrap: "nowrap",
    justify: "start",
    align: "stretch",
    gap: "0",
};
